import { render, staticRenderFns } from "./DashboardEventsSalesInvoices.vue?vue&type=template&id=64640e6e"
import script from "./DashboardEventsSalesInvoices.vue?vue&type=script&lang=js"
export * from "./DashboardEventsSalesInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports